// {Componente}{Verbo}{Acción}

// Tabla cotizaciones
export const QUOTATIONS_TABLE_SET_FILTERS = 'QUOTATIONS_TABLE_SET_FILTERS';

// quotations in done
// Para poner número de página, page size...
export const QUOTATIONS_PAGINATOR_SET_CONFIGURATION_DONE_QUOTATIONS = 'QUOTATIONS_PAGINATOR_SET_CONFIGURATION_DONE_QUOTATIONS';
export const QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_REQUEST = 'QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_REQUEST';
export const QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_SUCCESS = 'QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_SUCCESS';
export const QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_ERROR = 'QUOTATIONS_PAGINATOR_GET_DONE_QUOTATIONS_ERROR';

// quotations in Slopes to Emit
export const QUOTATIONS_PAGINATOR_SET_CONFIGURATION_SLOPES_EMIT_QUOTATIONS = 'QUOTATIONS_PAGINATOR_SET_CONFIGURATION_SLOPES_EMIT_QUOTATIONS';
export const QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_REQUEST = 'QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_REQUEST';
export const QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_SUCCESS = 'QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_SUCCESS';
export const QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_ERROR = 'QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_ERROR';

// quotations in Emitted
export const QUOTATIONS_PAGINATOR_SET_CONFIGURATION_EMITTED_QUOTATIONS = 'QUOTATIONS_PAGINATOR_SET_CONFIGURATION_EMITTED_QUOTATIONS';
export const QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_REQUEST = 'QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_REQUEST';
export const QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_SUCCESS = 'QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_SUCCESS';
export const QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_ERROR = 'QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_ERROR';
